/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_CopiedInputs */



/**
* | output |
* | --- |
* | "Key copied to clipboard" |
*
* @param {Options_Api_Keys_CopiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_copied = /** @type {((inputs?: Options_Api_Keys_CopiedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_CopiedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Clé copiée dans le presse-papiers")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schlüssel in die Zwischenablage kopiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiave copiata negli appunti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ключ скопирован в буфер обмена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Clave copiada al portapapeles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("密钥已复制到剪贴板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キーをクリップボードにコピーしました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुंजी क्लिपबोर्ड पर कॉपी हो गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Chave copiada para a área de transferência")
	return /** @type {LocalizedString} */ ("Key copied to clipboard")
});